import createReactComponent from '../createReactComponent';
var LogIn = createReactComponent('LogIn', [['path', {
  d: 'M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4',
  key: 'i2qegj'
}], ['polyline', {
  points: '10 17 15 12 10 7',
  key: '1ail0h'
}], ['line', {
  x1: '15',
  y1: '12',
  x2: '3',
  y2: '12',
  key: '80e4vw'
}]]);
export default LogIn;